import { Input } from "@/shadcn/components/ui/input";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import { EditedTask } from "@/types";
import React from "react";

type TaskCellTitleProps = {
  title: string;
  className: string;
  editedTitle?: string;
  editing: boolean;
  inputID: string;
  handleEditField?: (field: keyof EditedTask, value: string) => void;
};

const TaskCellTitle: React.FC<TaskCellTitleProps> = ({
  title,
  className,
  editedTitle,
  editing,
  inputID,
  handleEditField,
}) => {
  return editing && editedTitle && handleEditField ? (
    <div className={className}>
      <Input
        id={inputID}
        value={editedTitle}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => handleEditField("title", e.target.value)}
        maxLength={255}
      />
    </div>
  ) : (
    <TooltipProvider>
      <Tooltip delayDuration={400}>
        <TooltipTrigger asChild>
          <div className={className}>
            <div className="px-0 truncate">
              {editedTitle ? editedTitle : title}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent
          className="bg-accent outline outline-1 outline-white dark:outline-neutral-700/35 text-accent-foreground text-[15px]"
          align="start"
        >
          <div className="">{editedTitle ? editedTitle : title}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TaskCellTitle;
